import React,{useState, useEffect} from 'react';

import {
  LogoIco,
  Link,
  HeaderWrapper,
  LanguageSwitch,
  SwitchButton,
  DeviderIco,
} from './Header.styled';
import LogoSvg from '../../assets/images/Vidify.svg';
import DeviderSvg from '../../assets/images/LineVertical.svg';
import i18n from '../../language/i18n';

export const Header = () => {
const { language } = i18n;
const [isUk, setIsUk] = useState(true);

  const onChange = ({ target: { id } }) => {
    if(id!==isUk){
      i18n.changeLanguage(id);
      setIsUk(id==='uk')
    };
  };

  useEffect(() => {
    const lang=language.substring(0, 2);
   setIsUk(lang === 'uk')
  }, [])
  

  return (
      <HeaderWrapper>
        <Link href='#'>
          <LogoIco src={LogoSvg} alt='Logo' />
        </Link>
        <LanguageSwitch>
          <SwitchButton
            id='ru'
            active={!isUk}
            onClick={onChange}>
            RU
          </SwitchButton>
          <DeviderIco src={DeviderSvg} alt='|' />
          <SwitchButton
            id='uk'
            active={isUk}
            onClick={onChange}>
            UA
          </SwitchButton>
        </LanguageSwitch>
      </HeaderWrapper>
  );
};
